/* Paty · Colección — progressive enhancement. Dependency-free, deferred.
   Everything works without this file (plain links / GET forms); it adds:
     - collection page v2: sort auto-submit, filter popovers, mobile bottom sheet, "load more"
     - LEGACY block at the bottom: sort + drawer used by paty-search.liquid (paty-col__* classes) */
(function () {
  'use strict';

  /* ---------- Collection page v2 ---------- */

  // Sort: submit on change (a <noscript> button covers the no-JS case).
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (select && select.matches && select.matches('.paty-cl__sort-select') && select.form) {
      select.form.submit();
    }
  });

  // Filter popovers (<details data-paty-dd>): one open at a time, close on outside click / Escape.
  function closePopovers(except) {
    document.querySelectorAll('[data-paty-dd][open]').forEach(function (dd) {
      if (dd !== except) dd.removeAttribute('open');
    });
  }
  // `toggle` does not bubble: listen in the capture phase.
  document.addEventListener('toggle', function (e) {
    var dd = e.target;
    if (!dd || !dd.matches || !dd.matches('[data-paty-dd]') || !dd.open) return;
    closePopovers(dd);
    var pop = dd.querySelector('.paty-cl__pop');
    if (!pop) return;
    pop.classList.remove('is-right');
    var rect = pop.getBoundingClientRect();
    if (rect.right > document.documentElement.clientWidth - 8) pop.classList.add('is-right');
  }, true);
  document.addEventListener('click', function (e) {
    document.querySelectorAll('[data-paty-dd][open]').forEach(function (dd) {
      if (!dd.contains(e.target)) dd.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('[data-paty-dd][open]');
    if (!open) return;
    open.removeAttribute('open');
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  });

  // Mobile filter/sort bottom sheet. Without JS the :target CSS fallback shows it.
  if (!customElements.get('paty-col-sheet')) {
    customElements.define('paty-col-sheet', class extends HTMLElement {
      connectedCallback() {
        var self = this;
        this.wrap = this.querySelector('[data-sheet]');
        this.opener = null;
        this._onKey = function (e) {
          if (e.key === 'Escape') { self.close(); return; }
          if (e.key === 'Tab') self._trap(e);
        };
        this._onResize = function () { if (window.innerWidth >= 640) self.close(); };
        this.addEventListener('click', function (e) {
          var open = e.target.closest('[data-sheet-open]');
          if (open) { e.preventDefault(); self.open(open.getAttribute('data-sheet-open'), open); return; }
          if (e.target.closest('[data-sheet-close]')) { e.preventDefault(); self.close(); }
        });
      }
      _focusables() {
        return Array.prototype.filter.call(
          this.wrap.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,summary'),
          function (el) { return el.offsetParent !== null || el === document.activeElement; }
        );
      }
      _trap(e) {
        var f = this._focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      open(which, opener) {
        if (!this.wrap || this._isOpen) return;
        this._isOpen = true;
        this.opener = opener || null;
        this.wrap.classList.add('is-open');
        var sheet = this.wrap.querySelector('.paty-cl__sheet');
        if (sheet) { sheet.setAttribute('role', 'dialog'); sheet.setAttribute('aria-modal', 'true'); }
        document.body.classList.add('paty-cl-lock');
        document.addEventListener('keydown', this._onKey);
        window.addEventListener('resize', this._onResize);
        var sortAcc = this.wrap.querySelector('[data-sheet-sort]');
        if (sortAcc && which === 'sort') {
          sortAcc.open = true;
          sortAcc.scrollIntoView({ block: 'nearest' });
        }
        var target = (which === 'sort' && sortAcc && sortAcc.querySelector('input:checked')) ||
          this.wrap.querySelector('.paty-cl__sheet-x');
        if (target) target.focus({ preventScroll: true });
      }
      close() {
        if (!this._isOpen) return;
        this._isOpen = false;
        this.wrap.classList.remove('is-open');
        var sheet = this.wrap.querySelector('.paty-cl__sheet');
        if (sheet) { sheet.removeAttribute('role'); sheet.removeAttribute('aria-modal'); }
        document.body.classList.remove('paty-cl-lock');
        document.removeEventListener('keydown', this._onKey);
        window.removeEventListener('resize', this._onResize);
        if (this.opener) this.opener.focus();
      }
    });
  }

  // "Load more": fetch the next page through the Section Rendering API and append its cards.
  function announce(root, text) {
    var live = root.querySelector('[data-paty-live]');
    if (live) live.textContent = text;
  }
  function loadMore(btn) {
    var root = btn.closest('[data-paty-col]');
    var grid = root && root.querySelector('[data-paty-grid]');
    var more = btn.closest('[data-paty-more]');
    var nextUrl = btn.getAttribute('data-next-url');
    if (!root || !grid || !more || !nextUrl || btn.getAttribute('aria-busy') === 'true') return;

    var url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', root.getAttribute('data-section-id'));

    btn.setAttribute('aria-busy', 'true');
    grid.setAttribute('aria-busy', 'true');

    fetch(url.toString(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-paty-grid]');
        var cards = newGrid ? Array.prototype.filter.call(newGrid.children, function (el) {
          return el.classList.contains('paty-card');
        }) : [];
        if (!cards.length) throw new Error('empty page');

        var frag = document.createDocumentFragment();
        cards.forEach(function (card) { frag.appendChild(document.importNode(card, true)); });
        var first = frag.firstElementChild;
        grid.appendChild(frag);

        var newMore = doc.querySelector('[data-paty-more]');
        if (newMore) { more.innerHTML = newMore.innerHTML; enhance(more); } else { more.remove(); }

        // Keep the address bar on the page just loaded (a reload shows that page).
        try { window.history.replaceState(window.history.state, '', nextUrl); } catch (err) { /* ignore */ }

        var tOne = root.getAttribute('data-t-loaded-one') || 'producto más cargado';
        var tMany = root.getAttribute('data-t-loaded-many') || 'productos más cargados';
        announce(root, cards.length + ' ' + (cards.length === 1 ? tOne : tMany));
        var focusTarget = first && first.querySelector('.paty-card__link');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      })
      .catch(function () {
        // Anything went wrong: fall back to the plain paginated page.
        window.location.href = nextUrl;
      })
      .then(function () {
        grid.removeAttribute('aria-busy');
        btn.removeAttribute('aria-busy');
      });
  }
  function enhance(scope) {
    // The button is `hidden` in the markup so non-JS visitors only see the plain "next page" link.
    (scope || document).querySelectorAll('[data-more-btn][hidden]').forEach(function (b) { b.hidden = false; });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-more-btn]');
    if (!btn) return;
    e.preventDefault();
    loadMore(btn);
  });
  enhance(document);
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });

  /* ---------- LEGACY: paty-search.liquid (paty-col__* markup) ---------- */

  // Auto-submit del selector de orden; oculta el botón de respaldo (degradación sin JS).
  document.querySelectorAll('.paty-col__sort').forEach(function (form) {
    var select = form.querySelector('.paty-col__sort-select');
    var go = form.querySelector('.paty-col__sort-go');
    if (go) go.style.display = 'none';
    if (select) select.addEventListener('change', function () { form.submit(); });
  });

  // Drawer de filtros (móvil)
  if (!customElements.get('paty-filter-drawer')) {
    customElements.define('paty-filter-drawer', class extends HTMLElement {
      connectedCallback() {
        this.panel = this.querySelector('.paty-col__filters');
        this.overlay = this.querySelector('.paty-col__overlay');
        this._onKey = (e) => {
          if (e.key === 'Escape') { this.close(); return; }
          if (e.key === 'Tab') this._trap(e);
        };
        this.querySelectorAll('[data-open]').forEach((b) => b.addEventListener('click', () => this.open()));
        this.querySelectorAll('[data-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      }
      _focusables() {
        return this.panel.querySelectorAll('a[href],button,input,select,[tabindex]:not([tabindex="-1"])');
      }
      _trap(e) {
        var f = this._focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
      open() {
        if (this._isOpen) return;
        this._isOpen = true;
        this.classList.add('is-open');
        if (this.overlay) this.overlay.hidden = false;
        this.panel.setAttribute('role', 'dialog');
        this.panel.setAttribute('aria-modal', 'true');
        var toggle = this.querySelector('.paty-col__filters-toggle');
        if (toggle) { toggle.setAttribute('aria-expanded', 'true'); toggle.setAttribute('tabindex', '-1'); }
        document.body.classList.add('paty-no-scroll');
        document.addEventListener('keydown', this._onKey);
        var close = this.querySelector('.paty-col__filters-close');
        if (close) close.focus();
      }
      close() {
        if (!this._isOpen) return;
        this._isOpen = false;
        this.classList.remove('is-open');
        if (this.overlay) this.overlay.hidden = true;
        this.panel.removeAttribute('role');
        this.panel.removeAttribute('aria-modal');
        document.body.classList.remove('paty-no-scroll');
        document.removeEventListener('keydown', this._onKey);
        var toggle = this.querySelector('.paty-col__filters-toggle');
        if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.removeAttribute('tabindex'); toggle.focus(); }
      }
    });
  }
})();
